import React from "react";
import Button from "react-md/lib/Buttons/Button";
import RegistrationCard from "../RegistrationCard";

const HunterPermit = ({ onSubmit }) => (
  <RegistrationCard
    title="Do you have a valid hunting permit?"
    subtitle="Unfortunately, citizens from countries not listed
    are required to have a valid hunting permit
    in order to legally shoot at Orlando Gun Club"
    cardTitleClassName="hunter-permit--card-title"
  >
    <div>
      <section className="md-grid">
        <div className="md-cell md-cell--6" style={{ textAlign: "center" }}>
          <Button
            raised
            primary
            label="Yes"
            onClick={() => onSubmit({ hunterPermit: true })}
          />
        </div>
        <div className="md-cell md-cell--6" style={{ textAlign: "center" }}>
          <Button
            raised
            secondary
            label="No"
            onClick={() => onSubmit({ cancel: true })}
          />
        </div>
      </section>
    </div>
  </RegistrationCard>
);

export default HunterPermit;



// WEBPACK FOOTER //
// ./src/registration/components/HunterPermit/HunterPermit.jsx